import { useEffect, useRef } from 'react';
import app from '@src/scripts/react-habitat/app';
import renderRichText from '@src/scripts/util/renderRichText';

const useInnerBlocks = ( ...atts ) => {
	const ref = useRef();

	useEffect( () => {
		if ( ref.current ) {
			app.update( ref.current );
		}
	} );

	const InnerBlocks = renderRichText( ...atts );

	return { InnerBlocks, ref };
};

export default useInnerBlocks;
